import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

// Connects to data-controller="postcode"
export default class extends Controller {
  static targets = ["city"]

  connect() {
  }

  async change(e) {
    let response = await post(e.params.server, {
      body: JSON.stringify({ code: e.target.value }),
      contentType: "application/json",
      responseKind: "json"
    })
    if (response.ok) {
      let body = await response.json
      if (Object.keys(body).length == 0) {
        this.cityTarget.value = ""
      } else {
        this.cityTarget.value = body['city']
      }
    }
  }
}
